module.exports = __webpack_public_path__ + "image-c33006f6b8ea.png";